const allFields = require('./allFields.json');
const fieldBase = {
  defaultValue: '',
};

const extendFields = {
  accountName: {
    toggle: 'toggleContact',
  },
  accountNumber: {
    toggle: 'toggleContact',
  },
  lastName: {
    className: 'left-box'
  },
  suffix: {
    className: 'right-box'
  },
  barangay:{
    className: 'left-box'
  },
  zipCode:{
    className: 'right-box'
  },
  month:{
    className: 'minileft-box'
  },
  day:{
    className: 'minimiddle-box'
  },
  year:{
    className: 'miniright-box'
  },
  mchPassword: {
    ...fieldBase,
    renderStr: `<el-form-item label="New Password" prop="mchPassword">
      <NewPassword  v-model="dFormData.mchPassword" />
    </el-form-item>`
  },
  bankAccountType: {
    ...fieldBase,
    renderStr: `<el-form-item label="Bank" prop="bank">
      <AccountType v-model="dFormData.bankType" />
    </el-form-item>`
  },
  confirmPassword: {
    ...fieldBase,
    renderStr: `<el-form-item label="Confirm New Password" prop="confirmPassword">
        <ConfirmPassword v-model="dFormData.confirmPassword" />
      </el-form-item>`
  },
  'merchantId': {
    ...fieldBase,
    renderStr: `<BdoMerchantId v-model="dFormData.merchantId" />`
  },
  businessDescription:{
    ...fieldBase,
    renderStr: `<el-form-item label="Business Description" prop="businessDescription">
        <el-input type="textarea" resize="none" :rows="5" v-model="dFormData.businessDescription"  placeholder="Business Description" maxlength="256" ></el-input>
      </el-form-item>`
  }
  // barangay: {
  //   className: 'left-box',
  // },
  // zipCode: {
  //   className: 'right-box',
  // },
  // busiStoreName: {
  //   ...fieldBase,
  //   // renderStr: `<el-form-item label="Company Name">
  //   //     <el-input v-model="dFormData.companyName" placeholder="Company Name"></el-input>
  //   //   </el-form-item>`,
  // },
  // businessOwnership: {
  //   ...fieldBase,
  //   renderStr: `<el-form-item label="Do you own at least 20% of the business?" prop='least20'>
  //       <BdoRadios />
  //     </el-form-item>`,
  // },
  // busiStoreContact: {
  //   ...fieldBase,
  //   defaultValue: '',
  //   renderStr: `<el-form-item label="Contact Person" prop="busiStoreContact">
  //       <el-input v-model="dFormData.busiStoreContact"  placeholder="Contact Person" maxlength="${allFields["busiStoreContact"]["maxlength"]}" clearable></el-input>
  //     </el-form-item>`,
  // },
  // busiStoreMobileNumber: {
  //   ...fieldBase,
  //   type: 'MobileNumber',

  // },
  // busiStoreEmailAddress: {
  //   ...fieldBase,
  //   renderStr: `<el-form-item label="Email Address" prop="busiStoreEmailAddress">
  //       <el-input v-model="dFormData.busiStoreEmailAddress" placeholder="Email Address" maxlength="${allFields["busiStoreEmailAddress"]["maxlength"]}" clearable></el-input>
  //     </el-form-item>`,
  // },
  // 'optionEmailAddress': {
  //   toggle: 'toggleContact',
  // },
  // 'optionMobileNumber': {
  //   toggle: 'toggleContact',
  //   type: "MobileNumber",
  // },
  // 'optionLandline': {
  //   toggle: 'toggleContact',
  //   type: "LandlineNumber"
  // },

  // customLastName: {
  //   className: 'left-box'
  // },
  // customSuffix: {
  //   className: 'right-box'
  // },


  // customMobileNum: {
  //   ...fieldBase,
  //   type: 'MobileNumber',
  // },

  // customOptEmail: {
  //   toggle: 'toggleContact',
  // },
  // customOptMobile: {
  //   toggle: 'toggleContact',
  //   type: "MobileNumber",
  // },
  // customOptLandline: {
  //   toggle: 'toggleContact',
  //   type: "LandlineNumber",
  // },
  // accountName: {
  //   ...fieldBase,
  //   renderStr: `<el-form-item label="accountName"  v-show="toggleContact">
  //   <el-input v-model="dFormData.accountName"  placeholder="accountName" ></el-input>
  // </el-form-item>`,
  // },
  // accountNumber: {
  //   ...fieldBase,
  //   renderStr: `<el-form-item label="accountNumber"  v-show="toggleContact" >
  //   <el-input v-model="dFormData.accountNumber"  placeholder="accountNumber" ></el-input>
  // </el-form-item>`,
  // },
  // acrNumber: {
  //   toggle: 'toggleAcr'
  // },

  // tinNumber: {
  //   ...fieldBase,
  //   renderStr: `<el-form-item label="TIN" prop="tinNumber">
  //       <el-input v-model="dFormData.tinNumber" placeholder="TIN Number" :disabled="dFormData.tinStatus" maxlength="${allFields["tinNumber"]["maxlength"]}" clearable></el-input>
  //     </el-form-item>`,
  // },

  // tinStatus: {
  //   renderStr: `<div class="tin-box">
  //       <el-checkbox v-model="dFormData.tinStatus">I don't have a TIN</el-checkbox>
  //     </div>`,
  // },



  // busiStoreLandline: {
  //   ...fieldBase,
  //   type: 'LandlineNumber',
  // },

  // busiStoreMobileNum: {
  //   ...fieldBase,
  //   type: 'MobileNumber',
  // },

  // busiStoreMobile: {
  //   ...fieldBase,
  //   type: 'MobileNumber',
  // },

  // facebook: {
  //   toggle: 'toggleContact',
  // },
  // instagram: {
  //   toggle: 'toggleContact',
  // },
  // shopee: {
  //   toggle: 'toggleContact',
  // },
  // socialMedia: {
  //   toggle: 'toggleContact',
  // },
  // homeProState: {
  //   ...fieldBase,
  //   type: 'ProvinceSelect',
  // },
  // cityAndZipCode: {
  //   ...fieldBase,
  //   type: 'CityAndZipCode',
  // },
  // busiNature: {
  //   ...fieldBase,
  //   type: 'BusinessNatrue',
  // },
  // busiDescript: {
  //   ...fieldBase,
  //   type: 'BusinessDescrption',
  // },
  // busiStoreProState: {
  //   ...fieldBase,
  //   type: 'ProvinceSelect',
  // },
  // busiStoreCountry: {
  //   ...fieldBase,
  //   type: 'Select',
  // },
  // homeCountry: {
  //   ...fieldBase,
  //   type: 'Select',
  // },
  // birthDate: {
  //   ...fieldBase,
  //   type: 'SelectDate',
  // },
  // birthCountry: {
  //   ...fieldBase,
  //   type: 'Select',
  // },
  // birthCity: {
  //   ...fieldBase,
  //   type: 'Select',
  // },
  // citizenship: {
  //   ...fieldBase,
  //   type: 'BdoRadio',
  // },
  // yearsNumber: {
  //   ...fieldBase,
  //   type: 'Select',
  // },
  // acquirerStatus: {
  //   ...fieldBase,
  //   type: 'BdoRadio',
  // },
  // websiteUrl: {
  //   type: 'Input',
  // },
  // branchLandline: {
  //   ...fieldBase,
  //   type: 'LandlineNumber',
  // },
  // branchMobileNum: {
  //   ...fieldBase,
  //   type: 'MobileNumber',
  // },
  // branchProState: {
  //   ...fieldBase,
  //   type: 'ProvinceSelect',
  // }
}

// 将转换的字段与字段的扩展信息进行合并
const appFields = Object.keys(allFields).reduce((acc, item) => {
  const extendField = extendFields[item];
  if (extendField) {
    acc[item] = Object.assign(allFields[item], extendField)
  } else {
    acc[item] = allFields[item];
  }

  return acc;
}, {});
// 将extends存在但并没出现在allFields的字段加入fields中
Object.keys(extendFields).forEach((item) => {

  if (!appFields[item]) {
    appFields[item] = extendFields[item];
  }
});

const renderFieldWrapper = (getFieldTemplate, fields) => {

  return (field) => {
    console.log({
      field: fields[field]
    })
    const tField = fields[field] || { fieldName: field };
    return tField.renderStr || getFieldTemplate(tField);
  };
}

module.exports = {
  appFields,
  renderFieldWrapper,
};
